<!-- src/components/modals/TutorialVideoModal.vue -->
<template>
  <div v-if="isVisible" class="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/90 backdrop-blur-xl">
    <div class="bg-white rounded-3xl shadow-2xl w-full max-w-4xl overflow-hidden animate-videoPop border border-white/20">
      
      <!-- Video Header -->
      <div class="bg-slate-900 px-8 py-6 flex justify-between items-center border-b border-slate-800">
        <div>
          <h3 class="text-white text-xl font-black uppercase tracking-tight text-left">Onboarding Virtual Assistant</h3>
          <p class="text-[#20FCF1] text-[10px] font-bold uppercase tracking-widest mt-1 text-left">Tutorial: Completing Your Digital Induction</p>
        </div>
        <button @click="isVisible = false" class="text-slate-400 hover:text-white transition-colors p-2 hover:bg-slate-800 rounded-full">
          <XMarkIcon class="h-8 w-8" />
        </button>
      </div>

      <!-- Native Video Container -->
      <div class="relative bg-black aspect-video flex items-center justify-center">
        <video 
          :src="onboardingVideo" 
          controls 
          autoplay 
          playsinline
          class="w-full h-full object-contain"
        >
          Your browser does not support the video tag.
        </video>
      </div>

      <!-- Footer Info -->
      <div class="p-8 bg-white flex flex-col md:flex-row items-center justify-between gap-6 border-t text-left">
        <div class="flex items-center gap-4 text-left">
          <div class="p-3 bg-[#20FCF1]/10 rounded-full text-left">
            <InformationCircleIcon class="h-6 w-6 text-[#20FCF1]" />
          </div>
          <p class="text-sm font-bold text-slate-600 leading-tight max-w-md text-left">
            Please watch this guide in full. You will continue to see this video until your <span class="text-[#20FCF1] uppercase">Active</span> status is confirmed.
          </p>
        </div>
        
        <!-- UPDATED: BUTTON TEXT AND NAVIGATION HANDSHAKE -->
        <button 
          @click="navigateToForms" 
          class="bg-[#0A1630] text-white px-10 py-4 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-[#20FCF1] hover:text-[#0A1630] transition-all shadow-xl active:scale-95 text-center"
        >
          Complete Onboarding
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { XMarkIcon, InformationCircleIcon } from '@heroicons/vue/24/outline';
import onboardingVideo from '@/assets/onboarding-video.mp4';

const router = useRouter();
const isVisible = ref(true);

/**
 * 🛡️ PROTOCOL: NAVIGATE TO FORMS
 * Closes the modal and directs the user to the Identity Registry Forms
 */
const navigateToForms = () => {
  isVisible.value = false;
  router.push('/onboarding-forms');
};
</script>

<style scoped>
@keyframes videoPop {
  from { opacity: 0; transform: scale(0.95) translateY(30px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
.animate-videoPop { 
  animation: videoPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; 
}

video::-webkit-media-controls-panel {
  background-image: linear-gradient(transparent, rgba(30, 41, 59, 0.9));
}
</style>